import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { EStorageType } from "../data-types/storage.enum";
import { LocalStorageService } from "../services/local-storage.service";

@Injectable()
export class LoggedGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (LocalStorageService.instance.get(EStorageType.Token) !== null) {
      // not logged in so redirect to login page with the return url
      let role: string = LocalStorageService.instance.get(EStorageType.Role);
      switch (role) {
        case "coworking":
          this.router.navigate(["/coworking-home"]);

          break;
        case "coworker":
          this.router.navigate(["/coworker-home"]);

          break;
        case "company":
        case "company-plus":
          this.router.navigate(["/company-home"]);

          break;
        case "admin":
          this.router.navigate(["/backoffice"]);

          break;
      }
      return false;
    }

    return true;
  }
}
